'use client';
import React, { useEffect } from 'react';
import { useVisibleState } from '@/shared/hooks';
import { usePathname, useSearchParams, useParams } from 'next/navigation';
import { useAuthorization } from '@/entities/session';
import { AuthManagement } from '@/features/auth-managment';
import { ModalPrompts } from '@/features/data-managment';
import { PhoneRotatePrompt } from '@/features/phone-rotate-prompt';

import { WalletManagment } from '@/features/wallet-managment';
import { PingwinHeader } from '../header';
import { BonusNotificationModal } from '@/entities/bonus-notification/ui';
import { Footer } from '@/shared/ui/footer';
import { CashbackModal } from '@/entities/cashback/ui/cashback-modal';
import { Condition } from '../condition';
import { MobileMenu } from '../mobile-menu';
import { withBreakpointsSlice } from '@/shared/providers/utils/with-breakpoints-slice';
import {
  ContentWrapper,
  MainContentWrapper,
  MainWrapper,
  MobileMenuWrapper,
  UnderHeaderWrapper,
} from './styles';
// import { saveUTMParamsToCookies } from '@/shared/libs/saveUTMParamsToCookies';
import { useFullscreen } from '@/flat-pages/game/FullscreenContext';
import { useMediaQuery } from '@/shared/hooks/useMediaQuery';

const AuthLayout: React.FC = ({
  children,
  mobileLandscape,
  tablet,
  flexMain,
}) => {
  const { emailCodeAuthenticate } = useAuthorization();
  const searchParams = useSearchParams();
  const {
    open: openAuthManagment,
    visible: visibleAuthManagment,
    close: closeAuthManagmant,
  } = useVisibleState(false);
  const {
    open: openWalletManagment,
    visible: visibleWalletManagment,
    close: closeWalletManagmant,
  } = useVisibleState(false);

  const {
    open: openCashbackModal,
    visible: visibleCashbackModal,
    close: closeCashbackModal,
  } = useVisibleState(false);

  const pathname = usePathname();
  const params = useParams();
  const isPlayGame = Boolean(params?.titleGame);
  const isBetting = pathname.includes('/betting');

  const confirmationCodeParam = searchParams.get('confirmationCode');
  const triggerFromProfileParam = searchParams.get('triggerFromProfile');
  const refillBalanceParam = searchParams.get('refillBalance');

  useEffect(() => {
    if (refillBalanceParam) {
      openWalletManagment();
    }
  }, [refillBalanceParam]);

  function removeAllQueryParams() {
    const cleanUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, '', cleanUrl);
  }

  useEffect(() => {
    const handleQueryParams = async () => {
      if (confirmationCodeParam && triggerFromProfileParam) {
        try {
          await emailCodeAuthenticate(
            confirmationCodeParam,
            triggerFromProfileParam
          );
          removeAllQueryParams();
        } catch (error) {
          console.error('Error during email authentication:', error);
        }
      }
    };

    handleQueryParams();
  }, [confirmationCodeParam, triggerFromProfileParam]);

  // useEffect(() => {
  //   saveUTMParamsToCookies(searchParams);
  // }, [searchParams]);

  const { headerEnabled } = useFullscreen();
  const isPortrait = useMediaQuery('(orientation: portrait)');
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  const renderContent = () => {
    return (
      <>
        {(headerEnabled || isPortrait || isDesktop) && (
          <PingwinHeader openWalletManagment={openWalletManagment} />
        )}
        <UnderHeaderWrapper>
          <MainContentWrapper>
            <MainWrapper $flexMain={flexMain}>{children}</MainWrapper>
            <Condition match={!isPlayGame && !(isBetting && mobileLandscape)}>
              <Footer
                openCashbackModal={openCashbackModal}
                openWalletManagment={openWalletManagment}
              />
            </Condition>
          </MainContentWrapper>
          <Condition match={tablet}>
            <MobileMenu
              openWalletManagment={openWalletManagment}
              $flexMain={flexMain}
            />
          </Condition>
        </UnderHeaderWrapper>
        <AuthManagement
          onOpen={openAuthManagment}
          onClose={closeAuthManagmant}
          visible={visibleAuthManagment}
        />
        <ModalPrompts />
        <PhoneRotatePrompt />
        <WalletManagment
          onOpen={openWalletManagment}
          onClose={closeWalletManagmant}
          visible={visibleWalletManagment}
        />
        <BonusNotificationModal />
        <CashbackModal
          visible={visibleCashbackModal}
          onClose={closeCashbackModal}
        />
      </>
    );
  };

  return (
    <>
      <Condition match={tablet}>
        <MobileMenuWrapper $flexMain={flexMain}>
          <ContentWrapper $withoutMenu={isPlayGame} $flexMain={flexMain}>
            {renderContent()}
          </ContentWrapper>
          {/*<MobileMenu*/}
          {/*  openWalletManagment={openWalletManagment}*/}
          {/*  $flexMain={flexMain}*/}
          {/*/>*/}
        </MobileMenuWrapper>
      </Condition>
      <Condition match={!tablet}>{renderContent()}</Condition>
    </>
  );
};

const AuthLayoutWithBreakpointsSlice = withBreakpointsSlice(
  AuthLayout,
  ({ mobileLandscape, tablet }) => ({
    mobileLandscape,
    tablet,
  })
);

export { AuthLayoutWithBreakpointsSlice as AuthLayout };
